import krishnaLogo from '../assets/krishnalogo.png';

/**
 * Resolve clinic logo for display.
 * @param {string|null|undefined} logoPath - logo_path from clinic record
 * @param {string|null|undefined} logoUrlFromApi - pre-signed or public URL from API
 * @returns {string} Image src URL (never null — falls back to default Krishna logo)
 */
export function resolveClinicLogoSrc(logoPath, logoUrlFromApi) {
  if (logoUrlFromApi && String(logoUrlFromApi).trim()) {
    return String(logoUrlFromApi).trim();
  }

  if (logoPath && String(logoPath).trim()) {
    const raw = String(logoPath).trim();
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      return raw;
    }
    const path = raw.startsWith('/') ? raw : `/${raw}`;
    if (path.startsWith('/uploads/')) {
      const api = (process.env.REACT_APP_API_URL || '')
        .replace(/\/?api\/?$/i, '')
        .replace(/\/$/, '');
      if (api) return `${api}${path}`;
      return path;
    }
  }

  return krishnaLogo;
}

export { krishnaLogo as defaultClinicLogo };
